var _rect, _g, _g2, _rect2, _g3, _g4, _rect3, _rect4, _rect5, _rect6, _rect7, _rect8, _rect9, _rect10, _rect11, _rect12, _rect13, _rect14, _rect15, _rect16, _rect17, _rect18, _rect19, _rect20, _rect21, _rect22, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgSonicAdvantageTeaser01Big(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 558 358",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("mask", {
    id: "a",
    width: 432,
    height: 358,
    x: 0,
    y: 0,
    maskUnits: "userSpaceOnUse",
    style: {
      maskType: "alpha"
    }
  }, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 432,
    height: 358,
    fill: "#fff",
    rx: 28
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#a)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 8.425,
    cy: 152.501,
    r: 414.705,
    fill: "url(#b)"
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#c)"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 381,
    height: 283,
    x: 109,
    y: 36,
    fill: "#fff",
    rx: 8
  }))), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    width: 16,
    height: 16,
    x: 458,
    y: 47,
    fill: "#EAEAEA",
    rx: 8
  })), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#d)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "url(#e)",
    fillOpacity: 0.4,
    d: "M475 68H223c-6.351 0-11.5-5.149-11.5-11.5V55c0-6.627-5.373-12-12-12H133c-6.627 0-12 5.373-12 12v7a6 6 0 0 1-6 6 3 3 0 0 0-3 3v231.516c0 6.621 5.363 11.991 11.984 12l351 .468c6.634.009 12.016-5.366 12.016-12V80c0-6.627-5.373-12-12-12Z"
  }))), _g4 || (_g4 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#f)"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 477,
    height: 19,
    x: 61,
    y: 310,
    fill: "#fff",
    rx: 8
  }))), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    width: 82,
    height: 16,
    x: 125,
    y: 47,
    fill: "#111",
    rx: 8
  })), _rect4 || (_rect4 = /*#__PURE__*/React.createElement("rect", {
    width: 113,
    height: 20,
    x: 125,
    y: 87,
    fill: "#fff",
    rx: 10
  })), _rect5 || (_rect5 = /*#__PURE__*/React.createElement("rect", {
    width: 113,
    height: 20,
    x: 125,
    y: 158,
    fill: "#fff",
    rx: 10
  })), _rect6 || (_rect6 = /*#__PURE__*/React.createElement("rect", {
    width: 113,
    height: 20,
    x: 125,
    y: 229,
    fill: "#fff",
    rx: 10
  })), _rect7 || (_rect7 = /*#__PURE__*/React.createElement("rect", {
    width: 113,
    height: 7,
    x: 125,
    y: 184,
    fill: "#fff",
    rx: 3.5
  })), _rect8 || (_rect8 = /*#__PURE__*/React.createElement("rect", {
    width: 164,
    height: 7,
    x: 125,
    y: 195,
    fill: "#fff",
    rx: 3.5
  })), _rect9 || (_rect9 = /*#__PURE__*/React.createElement("rect", {
    width: 77,
    height: 7,
    x: 125,
    y: 206,
    fill: "#fff",
    rx: 3.5
  })), _rect10 || (_rect10 = /*#__PURE__*/React.createElement("rect", {
    width: 113,
    height: 7,
    x: 125,
    y: 113,
    fill: "#fff",
    rx: 3.5
  })), _rect11 || (_rect11 = /*#__PURE__*/React.createElement("rect", {
    width: 164,
    height: 7,
    x: 125,
    y: 124,
    fill: "#fff",
    rx: 3.5
  })), _rect12 || (_rect12 = /*#__PURE__*/React.createElement("rect", {
    width: 77,
    height: 7,
    x: 125,
    y: 135,
    fill: "#fff",
    rx: 3.5
  })), _rect13 || (_rect13 = /*#__PURE__*/React.createElement("rect", {
    width: 113,
    height: 7,
    x: 125,
    y: 255,
    fill: "#fff",
    rx: 3.5
  })), _rect14 || (_rect14 = /*#__PURE__*/React.createElement("rect", {
    width: 164,
    height: 7,
    x: 125,
    y: 266,
    fill: "#fff",
    rx: 3.5
  })), _rect15 || (_rect15 = /*#__PURE__*/React.createElement("rect", {
    width: 77,
    height: 7,
    x: 125,
    y: 277,
    fill: "#fff",
    rx: 3.5
  })), _rect16 || (_rect16 = /*#__PURE__*/React.createElement("rect", {
    width: 63,
    height: 16,
    x: 391,
    y: 47,
    fill: "#EAEAEA",
    rx: 8
  })), _rect17 || (_rect17 = /*#__PURE__*/React.createElement("rect", {
    width: 6,
    height: 6,
    x: 443,
    y: 52,
    fill: "#D8D8D8",
    rx: 3
  })), _rect18 || (_rect18 = /*#__PURE__*/React.createElement("rect", {
    width: 85,
    height: 16,
    x: 302,
    y: 47,
    fill: "#EAEAEA",
    rx: 8
  })), _rect19 || (_rect19 = /*#__PURE__*/React.createElement("rect", {
    width: 6,
    height: 6,
    x: 376,
    y: 52,
    fill: "#D8D8D8",
    rx: 3
  })), _rect20 || (_rect20 = /*#__PURE__*/React.createElement("rect", {
    width: 82,
    height: 16,
    x: 216,
    y: 47,
    fill: "#EAEAEA",
    rx: 8
  })), _rect21 || (_rect21 = /*#__PURE__*/React.createElement("rect", {
    width: 6,
    height: 6,
    x: 286,
    y: 52,
    fill: "#D8D8D8",
    rx: 3
  })), _rect22 || (_rect22 = /*#__PURE__*/React.createElement("rect", {
    width: 6,
    height: 6,
    x: 196,
    y: 52,
    fill: "#EAEAEA",
    rx: 3
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "c",
    width: 421,
    height: 323,
    x: 89,
    y: 20,
    colorInterpolationFilters: "sRGB",
    filterUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    result: "hardAlpha",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 4
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 10
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.25 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_301_7523"
  }), /*#__PURE__*/React.createElement("feBlend", {
    in: "SourceGraphic",
    in2: "effect1_dropShadow_301_7523",
    result: "shape"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "d",
    width: 383,
    height: 279.984,
    x: 108,
    y: 39,
    colorInterpolationFilters: "sRGB",
    filterUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    in: "BackgroundImageFix",
    stdDeviation: 2
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "SourceAlpha",
    operator: "in",
    result: "effect1_backgroundBlur_301_7523"
  }), /*#__PURE__*/React.createElement("feBlend", {
    in: "SourceGraphic",
    in2: "effect1_backgroundBlur_301_7523",
    result: "shape"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "f",
    width: 517,
    height: 59,
    x: 41,
    y: 294,
    colorInterpolationFilters: "sRGB",
    filterUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    result: "hardAlpha",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 4
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 10
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.25 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_301_7523"
  }), /*#__PURE__*/React.createElement("feBlend", {
    in: "SourceGraphic",
    in2: "effect1_dropShadow_301_7523",
    result: "shape"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "b",
    x1: -292.999,
    x2: 335.603,
    y1: 270.433,
    y2: 106.442,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.1,
    stopColor: "#F7941D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F9ED32"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "e",
    x1: 299.5,
    x2: 299.5,
    y1: 43,
    y2: 315,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#3866C2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#3866C2",
    stopOpacity: 0
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSonicAdvantageTeaser01Big);
export default __webpack_public_path__ + "static/media/sonic-advantage-teaser-01-big.ab0b10e98bf400a4b35819661aac86b9.svg";
export { ForwardRef as ReactComponent };